function getEmbedUrl(youtubeUrl) {
  const url = new URL(youtubeUrl);
  const videoId = url.searchParams.get("v");
  const list = url.searchParams.get("list");
  const index = url.searchParams.get("index");

  let embedUrl = `https://www.youtube.com/embed/${videoId}`;
  const params = new URLSearchParams();
  if (list) params.append("list", list);
  if (index) params.append("index", index);
  if ([...params].length > 0) embedUrl += "?" + params.toString();

  return embedUrl;
}

function Index() {
  const youtubeLinks = [
    "https://www.youtube.com/watch?v=iEGj8Gi6M9w&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=1",
    "https://www.youtube.com/watch?v=00BDBHt63JY&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=2",
    "https://www.youtube.com/watch?v=5TPoLorI_ok&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=3",
    "https://www.youtube.com/watch?v=ddSkGBor6U8&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=4",
    "https://www.youtube.com/watch?v=pCpPprmdGV8&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=5",
    "https://www.youtube.com/watch?v=79kVgfDBPHU&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=6",
    "https://www.youtube.com/watch?v=HcYGkamSFPw&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=7",
    "https://www.youtube.com/watch?v=Hl9SlrwQHQ8&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=8",
    "https://www.youtube.com/watch?v=SEIjXuk8IUI&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=9",
    "https://www.youtube.com/watch?v=OajYVPcsIAQ&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=10",
    "https://www.youtube.com/watch?v=S68Wn6sNj_o&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=11",
    "https://www.youtube.com/watch?v=b868MuSY5Qk&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=12",
    "https://www.youtube.com/watch?v=Nxmp3vHl2EQ&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=13",
    "https://www.youtube.com/watch?v=zr8_u-77OAE&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=14",
    "https://www.youtube.com/watch?v=fJryvYlRQVg&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=15",
    "https://www.youtube.com/watch?v=yRqlPRgpW14&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=16",
    "https://www.youtube.com/watch?v=CBPUDd-PadI&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=17",
    "https://www.youtube.com/watch?v=SytXq6F1_f4&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=18",
    "https://www.youtube.com/watch?v=03FAshEg4Yc&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=19",
    "https://www.youtube.com/watch?v=q8Xp9bwZgQM&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=20",
    "https://www.youtube.com/watch?v=0yHIouYOHno&list=PLLPA69Qk8DNdZHCywup4lGou8zbKFGv8O&index=21"
  ];

  return (
    <div className="w-full mt-40 mb-20 flex flex-col items-center">
      <div className="w-[80%]">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {youtubeLinks.map((link, i) => (
            <div key={i} className="w-full h-auto aspect-video">
              <iframe
                className="w-full h-full"
                src={getEmbedUrl(link)}
                title={`YouTube video ${i + 1}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default Index;
